import clsx from 'clsx';
import { format } from 'date-fns';
import Image from 'next/image';
import React from 'react';

import SmartLink from '@/components/Primitive/SmartLink';

interface IPostCard {
  title: string;
  thumbnail: string;
  href: string;
  className?: string;
  category?: string;
  publishedDate?: string;
}

const PostCard = ({
  title,
  thumbnail,
  category,
  href,
  publishedDate,
  className,
}: IPostCard) => {
  return (
    <SmartLink to={href} className={clsx('group relative block', className)}>
      <div className="absolute h-full w-full opacity-0 transition-opacity group-hover:opacity-100 group-focus:opacity-100">
        <div className="absolute left-[-2px] top-[-2px] h-[calc(100%+4px)] w-[calc(100%+4px)] rounded-md border-8 border-neonBlue-500 blur-[3px] transition-all group-active:blur-sm" />
        <div className="absolute h-full w-full rounded-md border-4 border-white transition-all" />
      </div>
      {category && (
        <div className="text-vertical absolute left-2 top-10 rotate-180 text-sm text-cream">
          {category}
        </div>
      )}
      <div className="relative flex w-full flex-col space-y-4 p-8">
        <div className="w-full overflow-hidden  rounded-md">
          <Image
            src={thumbnail}
            alt={title}
            width={320}
            height={320}
            className="w-full object-cover"
          />
        </div>
        {publishedDate && (
          <time
            dateTime={publishedDate}
            className="text-sm uppercase text-cream"
          >
            {format(new Date(publishedDate), 'MMMM dd, yyyy')}
          </time>
        )}
        <h3 className="line-clamp-3-3 text-lg font-semibold text-cream !no-underline md:text-xl">
          {title}
        </h3>
        <div className="uppercase tracking-widest text-cream underline group-hover:text-offWhite">
          Read more
        </div>
      </div>
    </SmartLink>
  );
};

export default PostCard;
